import type { Tab } from './navigation';

/** Tabs administrativos incluidos en Clínica Plus. */
export const CLINIC_PLUS_TABS: Tab[] = ['bodega', 'tesoreria', 'usuarios', 'configuracion'];

export const CLINIC_PLUS_MODULES: { tab: Tab; label: string; desc: string; icon: string }[] = [
  { tab: 'agenda', label: 'Agenda', desc: 'Citas, confirmaciones y enlace público para pacientes', icon: '📅' },
  { tab: 'pacientes', label: 'Pacientes', desc: 'Registro con CUI, admisión y búsqueda rápida', icon: '👤' },
  { tab: 'expediente', label: 'Expediente', desc: 'Historial clínico, notas, recetas y documentos', icon: '📋' },
  { tab: 'signos', label: 'Signos / evaluación', desc: 'Vitales, antropometría o evaluación funcional', icon: '📈' },
  { tab: 'laboratorio', label: 'Laboratorio', desc: 'Órdenes LIS, resultados e impresión', icon: '🧪' },
  { tab: 'imagenologia', label: 'Imagenología', desc: 'Estudios RIS e informes radiológicos', icon: '🩻' },
  { tab: 'farmaciaPos', label: 'Farmacia POS', desc: 'Mostrador, inventario y venta en caja', icon: '💊' },
  { tab: 'cuentas', label: 'Cobros / FEL', desc: 'Cuentas, pagos y factura electrónica', icon: '🧾' },
  { tab: 'aseguradoras', label: 'Aseguradoras', desc: 'Pólizas, autorizaciones y reclamos', icon: '🛡️' },
  { tab: 'bodega', label: 'Inventario', desc: 'Compras, stock y movimientos de bodega', icon: '📦' },
  { tab: 'tesoreria', label: 'Tesorería', desc: 'Caja, arqueos y flujo de efectivo', icon: '🏦' },
  { tab: 'usuarios', label: 'Usuarios', desc: 'Roles, permisos y accesos del equipo', icon: '🔐' },
  { tab: 'configuracion', label: 'Marca', desc: 'Logo, colores y datos de la clínica', icon: '🎨' },
];

export const VET_PLUS_MODULES: { tab: Tab; label: string; desc: string; icon: string }[] = [
  { tab: 'veterinaria', label: 'Mascotas', desc: 'Ficha de mascota y dueño responsable', icon: '🐶' },
  { tab: 'expedienteVet', label: 'Expediente vet', desc: 'Historial clínico por mascota', icon: '📋' },
  { tab: 'vetInternamiento', label: 'Internamiento', desc: 'Jaulas, hospitalización y evolución', icon: '🏥' },
  { tab: 'vetMostrador', label: 'Tienda', desc: 'Alimentos y accesorios en mostrador', icon: '🦴' },
  { tab: 'vetFarmacia', label: 'Farmacia vet', desc: 'Medicamentos e insumos veterinarios', icon: '💊' },
  { tab: 'farmaciaPos', label: 'POS', desc: 'Cobro integrado en caja', icon: '🏪' },
  { tab: 'cuentas', label: 'Cuentas', desc: 'Facturación y cobros', icon: '🧾' },
  { tab: 'aseguradoras', label: 'Aseguradoras', desc: 'Convenios y reclamos', icon: '🛡️' },
  { tab: 'bodega', label: 'Inventario', desc: 'Stock central de insumos', icon: '📦' },
  { tab: 'tesoreria', label: 'Tesorería', desc: 'Arqueos y cierre de caja', icon: '🏦' },
  { tab: 'configuracion', label: 'Marca', desc: 'Personalización visual', icon: '🎨' },
];

export const OPTICA_PLUS_MODULES: { tab: Tab; label: string; desc: string; icon: string }[] = [
  { tab: 'optica', label: 'Examen', desc: 'Graduación optométrica completa', icon: '👁️' },
  { tab: 'opticaOrdenes', label: 'Taller', desc: 'Órdenes de lentes y seguimiento', icon: '🔧' },
  { tab: 'opticaInventario', label: 'Inventario', desc: 'Armazones, micas y accesorios', icon: '📦' },
  { tab: 'farmaciaPos', label: 'POS', desc: 'Venta en mostrador', icon: '💊' },
  { tab: 'cuentas', label: 'Cobros', desc: 'Cuentas y comprobantes', icon: '🧾' },
  { tab: 'aseguradoras', label: 'Aseguradoras', desc: 'Convenios corporativos', icon: '🛡️' },
  { tab: 'bodega', label: 'Bodega', desc: 'Compras y stock general', icon: '📦' },
  { tab: 'tesoreria', label: 'Tesorería', desc: 'Flujo de caja', icon: '🏦' },
  { tab: 'configuracion', label: 'Marca', desc: 'Logo y colores de su óptica', icon: '🎨' },
];
